import { TraitTypeColor } from '../traitTypes/TraitTypeColor';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
export class TraitRegistryCssSvg extends TraitRegistryCategory {
    label = 'SVG';
    constructor(parent) {
        super(parent);
        super.init();
    }
    fill = () => new TraitTypeColor({
        label: 'Fill',
        init: '#333'
    });
    strokeWidth = () => new TraitTypeNumericWithSlider({
        label: 'StrokeWidth',
        min: 0,
        max: 200,
        roundDecimals: 0
    });
    stroke = () => new TraitTypeColor({
        label: 'Strichfarbe',
        init: '#333'
    });
    fillOpacity = () => new TraitTypeNumericWithSlider({
        label: 'Füll-Transparenz',
        step: 0.01,
        default: 1,
        init: 0.85,
        min: 0,
        max: 1
    });
    strokeOpacity = () => new TraitTypeNumericWithSlider({
        label: 'Strich-Transparenz',
        step: 0.01,
        default: 1,
        init: 0.85,
        min: 0,
        max: 1
    });
}
